import React, { useEffect } from "react";
import TopNavigation from "../../../components/TopNavigation";
import CircleProgressBar from "../CircleProgressBar";
import * as Assets from "../../../utils/svg_assets";
import * as PageRoutes from "../../../utils/route_pages";
import { Base } from "../../../components/RootLayout";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "./style.scss";

const Result = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const detailResult = location?.state;
  const { detailQuestion } = props;

  const handleButton = (action) => {
    if (action == "retake") {
      navigate(PageRoutes.quiz + `/${params.categoryId}/${params.quizId}`);
    } else {
      navigate(PageRoutes.quiz);
    }
  };

  useEffect(() => {
    if (detailResult == null) {
      navigate(PageRoutes.quiz);
    }
  }, []);

  return (
    <Base>
      <TopNavigation
        titlePage="Result"
        toPath={-1}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div className="quiz-result-wrapper">
        <div className="result-body">
          <span className="result-text">{detailResult?.quiz?.name}</span>
          <CircleProgressBar
            style={{
              background:
                detailResult?.result > 49
                  ? `conic-gradient(
              #3ED091 ${detailResult?.result * 3.6}deg,
              #DCDCDC ${detailResult?.result * 3.6}deg
              )`
                  : `conic-gradient(
              #FF5829 ${detailResult?.result * 3.6}deg,
              #DCDCDC ${detailResult?.result * 3.6}deg
              )`,
            }}
            text={detailResult?.result}
          />
          <span>You have {detailResult?.result}% correct answers.</span>
          {detailQuestion?.is_completed ? null : detailResult?.result < 50 ? (
            <span className="text-center">
              Sorry, you don’t get any point for result lower than 50%
            </span>
          ) : (
            <>
              <span>You received a reward of:</span>
              <div className="point-wrapper">
                <img src={Assets.iconGoldCoin} alt="logo_image" />
                <span className="point-text">
                  {detailResult?.quiz?.points}{" "}
                  {detailResult?.quiz?.currency?.name}
                </span>
              </div>
            </>
          )}
        </div>
        <Row className="btn-wrapper">
          <Col md={6} sm={6} xs={6}>
            <div
              className="btn btn-style warning"
              onClick={() => handleButton("retake")}
            >
              Retake Quiz
            </div>
          </Col>
          <Col md={6} sm={6} xs={6}>
            <div
              className="btn btn-style outline"
              onClick={() => handleButton("close")}
            >
              Close
            </div>
          </Col>
        </Row>
        <div className="desc-wrapper">
          {detailQuestion?.is_completed ? (
            <span className="desc-text">You have taken this quiz before</span>
          ) : null}
          <span className="desc-text">
            Rewards is only for your first time of taking the quiz
          </span>
        </div>
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  detailQuestion: state.QuizSM.detailQuestion,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Result);
